import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

if( window.ws !== undefined && window.ws.REVERB_APP_KEY !== "" ) {
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: window.ws.REVERB_APP_KEY,
        wsHost: window.location.hostname,
        wsPort: window.ws.REVERB_PORT,
        wssPort: 443,
        forceTLS: (window.ws.REVERB_FORCE_TLS == 'no' ? false : true),
        enabledTransports: ['ws', 'wss']
    });
}
else {
    window.Echo = null;
}
